import { render, staticRenderFns } from "./Q10.vue?vue&type=template&id=4417cb74&"
import script from "./Q10.vue?vue&type=script&lang=ts&"
export * from "./Q10.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports